import React, { FC } from 'react';
import Image from 'next/image';
import { styled } from 'linaria/react';
import { FULL_LIST_USERS_NEW_YEAR_GIVEAWAY, WINNER_LIST_NEW_YEAR_GIVEAWAY } from '@shared/config';
import Title from './Title';
import otherPrizeImg from '../../assets/new-year/other-prize.png';
import { FullListWinners } from './FullListWinners';
import { FullListParticipants } from './FullListParticipants';
const AdditionalWinnersSection: FC = () => <AdditionalWinnersSectionWrapper>
    <ContentWrapper>
      <TextWrapper>
        <Title isResult color="dark">
          Дополнительные
          <br />
          победители
        </Title>
        <Description>
          1 000 ₽
          <ImageWrapper>
            <Image src={otherPrizeImg} alt="Дополнительный приз" width={171} height={193} />
          </ImageWrapper>
        </Description>
      </TextWrapper>
      <WinnersListWrapper>
        <StyledLink target="_blank" href={WINNER_LIST_NEW_YEAR_GIVEAWAY}>
          <FullListWinners />
        </StyledLink>
      </WinnersListWrapper>
      <VideoWrapper>
        <iframe allowFullScreen title="Итоги розыгрыша" width="100%" src="https://rutube.ru/video/embed/c5eac9fb347d3b00f9a1c78d970b04f5/?p=JCc6mUoOtdkIH-RLu7gmjw" allow="clipboard-write; autoplay" />
      </VideoWrapper>
      <ParticipantsListWrapper>
        <StyledLink target="_blank" href={FULL_LIST_USERS_NEW_YEAR_GIVEAWAY}>
          <FullListParticipants />
        </StyledLink>
      </ParticipantsListWrapper>
    </ContentWrapper>
  </AdditionalWinnersSectionWrapper>;
export default AdditionalWinnersSection;
const AdditionalWinnersSectionWrapper = /*#__PURE__*/styled('div')({
  name: "AdditionalWinnersSectionWrapper",
  class: "a1g448mt",
  propsAsIs: false
});
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c381mz5",
  propsAsIs: false
});
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "t9bcknl",
  propsAsIs: false
});
const Description = /*#__PURE__*/styled('div')({
  name: "Description",
  class: "d1keckk4",
  propsAsIs: false
});
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "ipx0rq2",
  propsAsIs: false
});
const WinnersListWrapper = /*#__PURE__*/styled('div')({
  name: "WinnersListWrapper",
  class: "w23rzcu",
  propsAsIs: false
});
const ParticipantsListWrapper = /*#__PURE__*/styled('div')({
  name: "ParticipantsListWrapper",
  class: "pc3kva0",
  propsAsIs: false
});
const VideoWrapper = /*#__PURE__*/styled('div')({
  name: "VideoWrapper",
  class: "vmhebpj",
  propsAsIs: false
});
const StyledLink = /*#__PURE__*/styled('a')({
  name: "StyledLink",
  class: "s1ke8cmp",
  propsAsIs: false
});

require("./AdditionalWinnersSection.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./AdditionalWinnersSection.tsx");